import { DefaultLayout, AuthLayout } from "@/layouts/index";
import DashboardVue from "@/views/dashboard/index.vue";
import ComplaintVue from "@/views/complaint/index.vue";
import ComplaintDetail from "@/views/complaint/detail.vue";
import ComplaintStatusVue from "@/views/complaint-status/index.vue";
import FlightStatusVue from "@/views/flight-status/index.vue";
import { MENU_ID } from "@/app/menu";

const authPrefix = "/auth";
const pagesPrefix = "/pages";
const adminPrefix = "/admin";

const blankRoutes = [
  {
    path: `/auth/redirect`,
    name: "AuthCallback",
    component: () => import("@/components/account/AuthRedirect.vue"),
    meta: { title: "Redirect..", authRequired: false },
  },
].map((data) => {
  return {
    ...data,
    meta: { ...data.meta },
  };
});

const homepageRoutes = [
  {
    path: "/",
    name: "HomePage",
    component: DashboardVue,
    meta: {
      title: "HomePage",
      layout: DefaultLayout,
      authRequired: true,
      expectedMenu: MENU_ID.Complaint,
    },
  },
];

const complaintRoutes = [
  // {
  //   path: "/flight-status",
  //   name: "FlightStatus",
  //   component: FlightStatusVue,
  //   meta: {
  //     title: "FlightStatus",
  //     layout: DefaultLayout,
  //     authRequired: true,
  //     expectedMenu: MENU_ID.FlightStatus,
  //   },
  // },
  {
    path: "/complaint",
    name: "Complaint",
    component: ComplaintVue,
    meta: {
      title: "Complaint",
      layout: DefaultLayout,
      authRequired: true,
      expectedMenu: MENU_ID.Complaint,
    },
  },
  {
    path: "/complaint/:mainTopicId/:subTopicId",
    name: "NewComplaint",
    component: ComplaintDetail,
    meta: {
      title: "New Complaint",
      layout: DefaultLayout,
      authRequired: true,
      expectedMenu: MENU_ID.Complaint,
    },
  },
  {
    path: "/complaint/:requestNo",
    name: "ComplaintDetail",
    component: ComplaintDetail,
    meta: {
      title: "Complaint Detail",
      layout: DefaultLayout,
      authRequired: true,
      expectedMenu: MENU_ID.Complaint,
    },
  },
  {
    path: "/complaint-status",
    name: "ComplaintStatus",
    component: ComplaintStatusVue,
    meta: {
      title: "ComplaintStatus",
      layout: DefaultLayout,
      authRequired: true,
      expectedMenu: MENU_ID.ComplaintStatus,
    },
  },
  // {
  //   path: `/flight-information`,
  //   name: "ERDFlightInformationManagement",
  //   component: () => import("@/views/admin/FlightInformationManagement.vue"),
  //   meta: {
  //     title: "Flight Information Management",
  //     layout: DefaultLayout,
  //     authRequired: true,
  //     expectedMenu: MENU_ID.AdminFlight,
  //   },
  // },
  {
    path: `/complaint-list`,
    name: "RequestManagementEdit",
    component: () => import("@/views/admin/RequestManagement.vue"),
    meta: {
      title: "Request Management",
      layout: DefaultLayout,
      authRequired: true,
      expectedMenu: MENU_ID.ComplaintList,
    },
  },
  {
    path: `/complaint-ocpb`,
    name: "ComplaintOcpb",
    component: () => import("@/views/ocpb/index.vue"),
    meta: {
      title: "Request Management",
      layout: DefaultLayout,
      authRequired: true,
      expectedMenu: MENU_ID.ComplaintOcpb,
    },
  },
  {
    path: "/complaint-ocpb/:requestNo",
    name: "ComplaintOcpbDetail",
    component: () => import("@/views/ocpb/detail.vue"),
    meta: {
      title: "Complaint Detail",
      layout: DefaultLayout,
      authRequired: true,
      expectedMenu: MENU_ID.Complaint,
    },
  },
  {
    path: `/complaint-opm`,
    name: "ComplaintOpm",
    component: () => import("@/views/opm/index.vue"),
    meta: {
      title: "Request Management",
      layout: DefaultLayout,
      authRequired: true,
      expectedMenu: MENU_ID.ComplaintOpm,
    },
  },
  {
    path: "/complaint-opm/:requestNo",
    name: "ComplaintOpmDetail",
    component: () => import("@/views/opm/detail.vue"),
    meta: {
      title: "Complaint Detail",
      layout: DefaultLayout,
      authRequired: true,
      expectedMenu: MENU_ID.Complaint,
    },
  },
];

const authRoutes = [
  {
    path: `${authPrefix}/403`,
    name: "Error403",
    component: () => import("@/views/authentication/error/403.vue"),
    meta: { title: "404 Error", authRequired: false },
  },
  {
    path: `${authPrefix}/404`,
    name: "Error404",
    component: () => import("@/views/authentication/error/404.vue"),
    meta: { title: "404 Error", authRequired: false },
  },
  {
    path: `${authPrefix}/500`,
    name: "Error500",
    component: () => import("@/views/authentication/error/500.vue"),
    meta: { title: "500 Error", authRequired: false },
  },
  {
    path: `${authPrefix}/503`,
    name: "Error503",
    component: () => import("@/views/authentication/error/503.vue"),
    meta: { title: "503 Error", authRequired: false },
  },
  {
    path: `${authPrefix}/offline`,
    name: "Offline",
    component: () => import("@/views/authentication/error/Offline.vue"),
    meta: { title: "Offline Page", authRequired: false },
  },
];

const pagesRoutes = [
  {
    path: `${pagesPrefix}/access-denied`,
    name: "PagesAccessDenied",
    component: () => import("@/views/pages/AccessDenied.vue"),
    meta: { title: "Maintenance", authRequired: false },
  },
  {
    path: `${pagesPrefix}/maintenance`,
    name: "PagesMaintenance",
    component: () => import("@/views/pages/Maintenance.vue"),
    meta: { title: "Maintenance", authRequired: false, layout: AuthLayout },
  },
  {
    path: `${pagesPrefix}/coming-soon`,
    name: "PagesComingSoon",
    component: () => import("@/views/pages/ComingSoon.vue"),
    meta: { title: "Coming Soon", authRequired: false, layout: AuthLayout },
  },
];

const adminRoutes = [
  // {
  //   path: `${adminPrefix}/flight-information`,
  //   name: "FlightInformationManagement",
  //   component: () => import("@/views/admin/FlightInformationManagement.vue"),
  //   meta: { title: "Flight Information Management" },
  // },
  {
    path: `${adminPrefix}/user-management`,
    name: "UserManagement",
    component: () => import("@/views/admin/UserManagement.vue"),
    meta: { title: "User Management" },
  },
  {
    path: `${adminPrefix}/complaint-topic`,
    name: "ComplaintTopicManagement",
    component: () => import("@/views/admin/ComplaintTopicManagement.vue"),
    meta: { title: "Complaint Topic Management" },
  },
  {
    path: `${adminPrefix}/form-management`,
    name: "FormManagement",
    component: () => import("@/views/admin/FormManagement.vue"),
    meta: { title: "Form Management" },
  },
  {
    path: `${adminPrefix}/form-management/:id`,
    name: "FormManagementEdit",
    component: () => import("@/views/admin/FormManagement.vue"),
    meta: { title: "Add/Edit Form" },
  },
  {
    path: `${adminPrefix}/ticket-channel-management`,
    name: "TicketChannelManagementEdit",
    component: () => import("@/views/admin/TicketChannelManagement.vue"),
    meta: { title: "Ticket Channel Management" },
  },
  {
    path: `${adminPrefix}/responsible-person`,
    name: "ResponsibleManagement",
    component: () => import("@/views/admin/ResponsibleManagement.vue"),
    meta: { title: "Responsible Management" },
  },
  {
    path: `${adminPrefix}/permission`,
    name: "PermissionManagement",
    component: () => import("@/views/admin/PermissionManagement.vue"),
    meta: { title: "Permission Management" },
  },
].map((data) => {
  return {
    ...data,
    meta: {
      ...data.meta,
      layout: DefaultLayout,
      authRequired: true,
      expectedMenu: MENU_ID.Admin,
    },
  };
});

const webViewMobileRoutes = [
  {
    path: "/guidelines/:mainTopicId/:subTopicId",
    name: "ComplaintGuidelines",
    component: () => import("@/views/guideline/index.vue"),
    meta: { title: "Complaint Guidelines", authRequired: false },
  },
  {
    path: "/guidelines-airlines/:mainTopicId/:subTopicId",
    name: "ComplaintGuidelinesAirlines",
    component: () => import("@/views/guideline/airline.vue"),
    meta: { title: "Complaint Guidelines Airlines", authRequired: false },
  },
];

export const routes = [
  ...blankRoutes,
  ...homepageRoutes,
  ...complaintRoutes,
  ...authRoutes,
  ...pagesRoutes,
  ...adminRoutes,
  ...webViewMobileRoutes,
  {
    path: "/logout",
    name: "Logout",
    component: () => import("@/views/account/Logout.vue"),
    meta: { title: "Logout", authRequired: false },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notfound",
    component: () => import("@/views/authentication/error/404.vue"),
  },
];
